import React, { useEffect, useState } from 'react';
import { callback, createSigner } from '../../redux/actions/SignerAction';
import Loading from '../Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../Error/ErrorPage';

const Callback = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation('common');
  const [isSigningFlow, setIsSigningFlow] = useState(false);
  const { CallbackData, fetching, error } = useSelector((state) => ({
    CallbackData: state.sign.callback,
    fetching: state.sign.fetching,
    error: state.error.isError
  }));

  const [state, setState] = useState({
    portallogo: "",
    languageCode: "",
    genericError: false
  });
  const { createSignerUrl } = useSelector((state) => ({
    createSignerUrl: state.sign.createSignerUrl
  }));
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const sign_id = urlParams.get("sign_id");
    const code = urlParams.get("code");
    const stateParam = urlParams.get("state");
    const signerId = urlParams.get("signerId");

    if (sign_id) {
      setIsSigningFlow(true);
      let authorizationResponse = {
        SignId: sign_id,
        SignerId: signerId,
        UpdateSSN: window.globalConfig.UpdateSSN === "true"
      };

      dispatch(callback(authorizationResponse));
      return;
    }
    if (code && stateParam) {
      setIsSigningFlow(false);
      let authorizationResponse = {
        Code: code,
        State: stateParam,
        UpdateSSN: window.globalConfig.UpdateSSN === "true"
      };
      dispatch(callback(authorizationResponse));
      return;
    }
    setState(prev => ({ ...prev, genericError: true }));

  }, [dispatch]);

  useEffect(() => {
    if (CallbackData?.data) {
      const settings = CallbackData.data;

      setState(prev => ({
        ...prev,
        portallogo: settings.ImageUrl,
        languageCode: settings.LanguageCode
      }));
    }
  }, [CallbackData]);
  useEffect(() => {
    if (!CallbackData?.data) return;
    if (CallbackData.data.IsBiometricSuccess) {
      const signer = JSON.parse(localStorage.getItem("pendingSigner"));
      if (!signer) {
        setState(prev => ({ ...prev, genericError: true }));
        return;
      }
      dispatch(createSigner(signer));
      localStorage.removeItem('pendingSigner');
      return;
    }

  }, [CallbackData, dispatch]);
  useEffect(() => {
    if (createSignerUrl && typeof createSignerUrl === "string") {
      window.location.href = createSignerUrl;
    }
  }, [createSignerUrl]);
  useEffect(() => {
    if (state.languageCode === 1033) {
      i18n.changeLanguage('en');
    } else if (state.languageCode === 1044) {
      i18n.changeLanguage('no');
    }
  }, [state.languageCode, i18n]);

  return (
    <div>
      {!error && fetching && <Loading />}

      <div className="navbar navbar-inverse navbar-fixed-top">
        <div className="container justify-content-center">
          <div className="navbar-header">
            {state.portallogo ? (
              <img
                src={state.portallogo}
                height="50"
                className="navbar-brand"
                alt="E-Sign Portal"
              />
            ) : (
              <span className="navbar-brand">E-Sign Portal</span>
            )}
          </div>
        </div>
      </div>

      {error || state.genericError ? (
        <ErrorPage />
      ) : !isSigningFlow ? (
        <Loading />
      ) : (
        <div className="successmessage">
          <h1 className="display-3">{t('esign.thankyouMsg')}</h1>
          <FontAwesomeIcon className="successicon" icon={faCheck} />
          <p>{t('esign.documentSignerMsg')}</p>
        </div>
      )}
    </div>
  );
};

export default Callback;